const baseURL = (typeof(window) !== 'undefined' ? window.location.origin : null) ;
const Ajax = require('./ajax');


exports.getAdminReviewEvidence = function(){
   return Ajax.get(baseURL + '/evidence/getAdminReview');
};

exports.getAdminReviewConjecture = function(){
   return Ajax.get(baseURL + '/reasoning/getAdminReview');
};

exports.getAdminStats = function(){
   return Ajax.get('/getAdminStats');
};

exports.manuallyApproveEvidence = function(idCard){
   return Ajax.post(baseURL + '/votes/manualApproval', {idCard})
};

exports.manuallyRejectEvidence = function(idCard, rejectMessage){
   return Ajax.post(baseURL + '/votes/manualReject', {idCard, rejectMessage})
};

exports.manuallyApproveConjecture = function(idCard){
   return Ajax.post(baseURL + '/votes/manualApproveConjecture', {idCard})
};

exports.manuallyRejectConjecture = function(idCard, rejectMessage){
   return Ajax.post(baseURL + '/votes/manualRejectConjecture', {idCard, rejectMessage})
};

exports.assignUserRole = function(idUser, idRole) {
   return Ajax.post(baseURL + '/admin/assignUserRole', { idUser, idRole });
}

exports.unassignUserRole = function(idUser, idRole) {
   return Ajax.post(baseURL + '/admin/unassignUserRole', { idUser, idRole });
}

exports.addEmailToWhitelist = function(email){
   return Ajax.post(baseURL + "/addEmailToWhitelist", {email});
};

exports.createNewsPost = function(title, text){
   return Ajax.post(baseURL + '/admin/createNewsPost', {title, text});
};

exports.getCurHeadlines = function(){
   return Ajax.get('/admin/getCurHeadlines');
};

exports.getCurAMACards = function(){
   return Ajax.get('/admin/getCurAMACards');
};

exports.createHeadline = function(headline){
   return Ajax.post(baseURL + '/admin/createHeadline', {headline: JSON.stringify(headline)});
};

exports.createAMACard = function(amaCard){
   return Ajax.post(baseURL + '/admin/createAMACard', {amaCard: JSON.stringify(amaCard)});
};

exports.updateHeadline = function(headline){
   return Ajax.post(baseURL + '/admin/updateHeadline', {headline: JSON.stringify(headline)});
};

exports.updateAMACard = function(amaCard){
   return Ajax.post(baseURL + '/admin/updateAMACard', {amaCard: JSON.stringify(amaCard)});
};


exports.deleteHeadline = function(idHeadline){
   return Ajax.post(baseURL + '/admin/deleteHeadline', {idHeadline});
};

exports.deleteAMACard = function(idAMACard){
   return Ajax.post(baseURL + '/admin/deleteAMACard', {idAMACard});
};

exports.getUserList = function(){
   return Ajax.get('/admin/getUserList');
};

exports.deleteUser = function(idUser) {
   return Ajax.post('/admin/deleteUser', { idUser });
}

exports.getAdminViewDataByID = function(id){
   return Ajax.get('/admin/getAdminViewDataByID?id='+id);
};

exports.getAdminUserData = function(){
   return Ajax.get('/admin/getAdminUserData');
};

exports.verifyUserEmail = function(idUser) {
   return Ajax.post('/admin/verifyUser', { idUser });
}